import { CheckCircle2 } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";
import { IMAGES } from "@/lib/site";

const POINTS = [
  "#1 home workout creator with 4M+ followers",
  "10,000+ documented member transformations",
  "Certified trainer & fat-loss specialist, 12 years",
  "Featured in top fitness publications worldwide",
];

export const CreatorIntro = () => (
  <section id="creator" data-testid="creator-section" className="py-24 md:py-32 bg-slate-900">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col-reverse lg:flex-row items-center gap-14 lg:gap-24">
      <Reveal className="relative flex-1 w-full max-w-md lg:max-w-none">
        <div className="absolute -inset-4 rounded-[3rem] bg-blue-500/10 rotate-2" aria-hidden="true" />
        <img data-testid="creator-image" src={IMAGES.creator} alt="Bryan Lee, home workout creator" className="relative rounded-[2.5rem] w-full aspect-[4/5] object-cover object-[50%_20%] shadow-[0_20px_50px_rgb(0,0,0,0.12)]" loading="lazy" />
      </Reveal>
      <div className="flex-1 max-w-xl">
        <Reveal>
          <p className="text-sm uppercase tracking-[0.2em] font-bold text-blue-400 mb-4">Meet your coach</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-extrabold text-white leading-tight">Hi, I'm Bryan Lee.</h2>
          <p className="mt-6 text-base sm:text-lg text-slate-400 leading-relaxed">
            I built my following by doing one thing differently: making fitness work for people who hate working out. No 2-hour gym sessions. No complicated routines. Just short, simple follow-along workouts that fit real life — and actually get results.
          </p>
        </Reveal>
        <div className="mt-8 space-y-4">
          {POINTS.map((point, i) => (
            <Reveal key={point} delay={0.08 * i} className="flex items-start gap-3">
              <CheckCircle2 size={22} className="text-blue-400 shrink-0 mt-0.5" />
              <p data-testid={`creator-point-${i}`} className="text-base font-semibold text-slate-200">{point}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3} className="mt-9 rounded-2xl bg-slate-950 border border-slate-800 p-6">
          <p className="text-base sm:text-lg text-slate-300 italic leading-relaxed">"My promise: if you can press play, I can get you results. I'll meet you exactly where you are — even if that's the couch."</p>
        </Reveal>
      </div>
    </div>
  </section>
);
